import React, { useState, useContext } from 'react'
import '../../styles/Admin/profile.css'
import Sidebar from '../../components/Admin/Sidebar'
import Head from '../../components/Admin/Head'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faClose, faUser } from '@fortawesome/free-solid-svg-icons'
import { states } from '../../data/userstates'
import { ShareContext } from '../../context/ShareContext';
import * as Constants from '../../constants';
import Expired from '../../components/Expired'
import ApiAlert from '../../components/ApiAlert'
import Loading from '../../components/Loading'
import { useNavigate, useParams } from 'react-router-dom'

function Profile() {
  const navigate = useNavigate()
  const { adminUserDetails, isSidebarClosed,  setIsAdminLoggedIn, setAdminData, adminToken } = useContext(ShareContext);

  const [passwordOrEdit, setPasswordOrEdit] = useState('')
  const [showPop, setShowPop] = useState(false)

  // console.log(adminUserDetails);
  
  const profile =adminUserDetails ;
  const [form, setForm] = useState(adminUserDetails)
  const [newPassword, setnewPassword] = useState({
    oldPassword: '',
    newPassword: '',
    retypePassword: '',
    userid:form.userid,
  })
  const [changeGood, setChangeGood] = useState('');
  const [whichInp, setWhichInp] = useState('')

  const formChange = (e) => {
    setForm({...form, [e.target.name]: e.target.value})
  }

  const passChange = (e) => {
    setnewPassword({...newPassword, [e.target.name]: e.target.value})
  }

  const closePop = () => {
    setShowPop(false)
    setPasswordOrEdit('')
  }

  const showEdit = () => {
    setShowPop(true)
    setPasswordOrEdit('edit')
  }

  const passwordChange = () => {
    setShowPop(true)
    setPasswordOrEdit('password')
  }

  const changePassword = (e) => {
    e.preventDefault();
    setChangeGood('');
     if (newPassword.recentPassword !== newPassword.retypePassword) {
      setWhichInp('new')
      setChangeGood('New password and the retyped new password do not match')
    } else if(newPassword.oldPassword === '' || newPassword.recentPassword === '' || newPassword.retypePassword === '') {
      setWhichInp('all')
      setChangeGood('Please enter all inputs')
    } 
  }
 
  const [loading, setLoading]=useState(false);
  const [loginError, setLoginError] = useState('')
  const [isExpired, setIsExpired] = useState(false);
  const [alert, setAlert] =useState({open:false, title:'', subtitle:''});

  
  const logOut = () => {
    // Clear token from local storage
    localStorage.removeItem('adminToken');
  
    // Clear other user-related data from local storage
    localStorage.removeItem('adminDetails');
  
    // Set user logged in state to false
    setIsAdminLoggedIn(false);
  
    // Navigate to the login page
    navigate('/admin');
  };
  const onCompleted=()=>{
    //after the alert message, then it should 
    setAlert({open:false});
    logOut();
}
  const onChangePassword = async(e) => {
          e.preventDefault();

          setChangeGood('');
          if (newPassword.newPassword !== newPassword.retypePassword) {
           setWhichInp('new')
           setChangeGood('New password and the retyped new password do not match')
           console.log(`new pass ${newPassword.newPassword} retry ${newPassword.retypePassword}`)
           return;
         } else if(newPassword.oldPassword === '' || newPassword.newPassword === '' || newPassword.retypePassword === '') {
           setWhichInp('all')
           setChangeGood('Please enter all inputs')
           
           return;
         } 
  
         
              setLoading(true);
              try{
                  const response = await fetch(`${Constants.apiUrl}/parkingadmin/changepassword`, {
                      method: 'POST',
                      headers: {
                          'Content-Type': 'application/json',
                          'Authorization': adminToken,
                      },
                      body: JSON.stringify(newPassword)
                  })
                  
                  const data = await response.json()
                  setLoading(false);
                  if (data.code == 0) {
                    setShowPop(true)
                      setAlert({open:true, title:'Password Reset', subtitle:"Password reset completed. Please login with the new password.", onOk:onCompleted})
          
                    }else if(data.code==-10){
                      setIsExpired(true);
                    }
                    else {
                      setLoginError(data.status)
                      setChangeGood(data.status);
                    }
              } catch (error){
                  setLoginError('Failed Login')
                  setLoading(false);
              }
  
          
      }


const onSave = async(e) => {
    e.preventDefault();
    setLoading(true)
    var rdata={user:form}

    const url= `${Constants.apiUrl}/parkingadmin/updateclient/${form.userid}`;
    console.log(JSON.stringify(rdata));
      fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': adminToken
        },
        body: JSON.stringify(rdata)
      })
      .then((resp) => resp.json())
      .then((data) => {
        if (data.code === 0) {
          setLoading(false)
          setShowPop(false)
         
          setAlert({open:true, title:'Password Reset', subtitle:"Congratulations, User account successfully updated", onOk:onCompleted})
          //update the row
          
        }else if (data.code==-10){
          setIsExpired(true);
      }else{
          alert(data.status)
      }
      }).catch((error) => {
        console.log(error);
        setLoading(false)
      })

    // console.log(createData);

  }

  return (
    <div className='admin-body'>
        <Sidebar />
        <div className={ isSidebarClosed ? "right-side full" : "right-side"}>
            <Head />
            <div className="profile">
                <h1>User Profile</h1>
                <div className="body">
                  <div className="header">
                    <div className="name">
                      <FontAwesomeIcon icon={faUser} />
                      <h2>{profile.firstName} <br /> {profile.lastName}</h2>
                    </div>
                    <div className="actions">
                      <button onClick={() => showEdit()}>Edit Profile</button>
                      <button onClick={() => passwordChange()}>Change Password</button>
                    </div>
                  </div>
                  <div className={showPop ? "adminUserDetails short": "details"}>
                    <div className="row">
                      <p className="title">First Name</p>
                      <p className="answer">{form.firstname}</p>
                    </div>
                    <div className="row">
                      <p className="title">Last Name</p>
                      <p className="answer">{form.lastname}</p>
                    </div>
                    <div className="row">
                      <p className="title">E-mail</p>
                      <p className="answer">{form.emailaddress}</p>
                    </div>
                    <div className="row">
                      <p className="title">Phone Number</p>
                      <p className="answer">{form.preferredphone}</p>
                    </div>
                    
                    <div className="row">
                      <p className="title">User ID</p>
                      <p className="answer">{form.userid}</p>
                    </div>
                  
                    <div className="row">
                      <p className="title">Alt Phone</p>
                      <p className="answer">{form.alternatephone}</p>
                    </div>
                    <div className="row">
                      <p className="title">Extension</p>
                      <p className="answer">{form.extension}</p>
                    </div>
                    <div className="row">
                      <p className="title">Address</p>
                      <p className="answer">{form.address1}</p>
                    </div>
                    <div className="row">
                      <p className="title">Address(2)</p>
                      <p className="answer">{form.address2}</p>
                    </div>
                    <div className="row">
                      <p className="title">City</p>
                      <p className="answer">{form.city}</p>
                    </div>
                    <div className="row">
                      <p className="title">State</p>
                      <p className="answer">{form.state}</p>
                    </div>
                    <div className="row">
                      <p className="title">ZIP Code</p>
                      <p className="answer">{form.zip}</p>
                    </div>
                    <div className="row">
                      <p className="title">Access Levels</p>
                      <p className="answer">{form.accessLevels}</p>
                    </div>
                    <div className="row">
                      <p className="title">Status</p>
                      <p className="answer active">{form.Userstatus}</p>
                    </div>
                  </div>
                </div>
                
                  <div className={ showPop ? "background show" :"background"}>
                    {
                      passwordOrEdit === 'edit' &&
                      <div className="container">
                      <div className="head">
                        <h3>Edit Profile</h3>
                        <FontAwesomeIcon icon={faClose} onClick={() => closePop()}/>
                      </div>
                      <form method="post" className="create"  onSubmit={onSave}>
                        <div className="input">
                          <label htmlFor="user-id">User ID</label>
                          <input type="text" id='user-id' name='userid' value={form.userid} onChange={formChange}/>
                        </div>
                        <div className="inputs">
                          <div className="input">
                            <label htmlFor="user-firstname">First Name</label>
                            <input type="text" id='user-firstname' name='firstname' value={form.firstname} onChange={formChange}/>
                          </div>
                          <div className="input">
                            <label htmlFor="user-lastname">Last Name</label>
                            <input type="text" id='user-lastname' name='lastName' value={form.lastname} onChange={formChange}/>
                          </div>
                        </div>
                        <div className="inputs">
                          <div className="input">
                            <label htmlFor="user-email">Email</label>
                            <input type="email" id='user-email' name='emailaddress' value={form.emailaddress} onChange={formChange}/>
                          </div>
                         
                        </div>
                        <div className="inputs">
                          <div className="input">
                            <label htmlFor="user-phone">Phone</label>
                            <input type="tel" id='user-phone' name='preferredphone' value={form.preferredphone
                            } onChange={formChange}/>
                          </div>
                          <div className="input">
                          <label htmlFor="user-altphone">Alt. Phone</label>
                            <input type="tel" id='user-altphone' name='alternatephone' value={form.alternatephone} onChange={formChange}/>
                          </div>
                          <div className="input">
                            <label htmlFor="user-extension">Extension</label>
                            <input type="text" id='user-extension' name='extension' value={form.extension} onChange={formChange}/>
                          </div>
                        </div>
                        <div className="input">
                          <label htmlFor="user-address">Address 1</label>
                          <input type="text" id='user-address' name='address1' value={form.address1} onChange={formChange}/>
                        </div>
                        <div className="input">
                          <label htmlFor="user-addressTwo">Address 2</label>
                          <input type="text" id='user-addressTwo' name='address2' value={form.address2} onChange={formChange}/>
                        </div>
                        <div className="inputs">
                          <div className="input">
                            <label htmlFor="user-city">City</label>
                            <input type="text" id='user-city' name='city' value={form.city} onChange={formChange}/>
                          </div>
                          <div className="input">
                            <label htmlFor="user-state">State</label>
                            <select name="state" id="user-state" value={form.state} onChange={formChange}>
                              <option value="" disabled selected>Select State/Province</option>
                              {
                                states.map(state => {
                                  return (
                                    <option value={state.code}>{state.name}</option>
                                  )
                                })
                              }
                            </select>
                          </div>
                        </div>
                        <div className="inputs">
                          <div className="input">
                            <label htmlFor="user-zip">ZIP Code</label>
                            <input type="text" id='user-zip' name='zip' value={form.zip} onChange={formChange}/>
                          </div>
                         
                        </div>
                        <div className="inputs">
                         
                          
                        </div>
                        <div className="btns">
                          <button type='submit'>Save</button>
                          <p className='goBack' onClick={() => closePop()}>Back to Profile</p>
                        </div>
                      </form>
                    </div>
                    }
                    {
                      passwordOrEdit === 'password' && 
                      <div className="container">
                      <div className="head">
                        <h3>Change Password</h3>
                        <FontAwesomeIcon icon={faClose} onClick={() => closePop()}/>
                      </div>
                      <form method="post" className="create">
                        <div className="input">
                          <label htmlFor="username">Username</label>
                          <input type="text" id='userid' name='userid' value={form.userid} disabled/>
                        </div>
                        <div className="input">
                          <label htmlFor="oldPassword">Old Password</label>
                          <input type="password" id='oldPassword' name='oldPassword' value={newPassword.oldPassword} onChange={passChange}/>
                        </div>
                        <div className="input">
                          <label htmlFor="newPassword">Type in New Password</label>
                          <input type="password" id='newpassword' name='newPassword' value={newPassword.newPassword} onChange={passChange}/>
                          <span style={{fontSize:13, color:'red', fontWeight:'bold'}}>Minimum of 8 characters, atlease one number and one special characters ($,*+ etc)</span>
                        </div>
                        <div className="input">
                          <label htmlFor="retypePassword">Retype New Password</label>
                          <input type="password" id='retypePassword' name='retypePassword' value={newPassword.retypePassword} onChange={passChange}/>
                        </div>
                        <div className="btns">
                          <button type='submit' onClick={onChangePassword}>Change Password</button>
                          <p className='goBack' onClick={() => closePop()}>Back to Profile</p>
                        </div>
                        <p className='error'>{changeGood}</p>
                      </form>
                    </div>
                    }
                  </div>
                
            </div>
        </div>
       

                { isExpired && <div className={  'congrats show'}> <Expired mode='admin' /> </div>}
                {alert.open && <div className={ "congrats show" }>
                <ApiAlert {...alert} />  
            </div> } 
    </div>
  )
}

export default Profile